import EmptyResults from './empty-results.component'

export default EmptyResults
